<template>

    <div class="service-results service-results-downloads">

        <loader :loading="resultState === 'loading'"></loader>

        <div v-show="(resultState === 'finished' || resultState === 'updating') && (hasFilter() || hasFilterSelected)"
             class="wrapper">

            <a aria-controls="resultoptions" aria-expanded="true"
               class="btn toggle-xs btn-resultoptions collapsed visible-xs"
               data-parent="#accordion" data-target="#resultoptions" data-toggle="collapse" role="button">
                {{ $t("service_download.filter_sorting.show_hide") }}<i class="icon icon-toggle-state"></i>
            </a>


            <div id="resultoptions" class="service-resultoptions form-flat collapse">
                <div class="result-option results-filter">
                    <h3 class="results-filter__headline">{{ $t("service_download.filter_sorting.facet_headline") }}</h3>

                    <div class="flex-row">

                        <category-filter v-show="!hideCategories" />

                        <div v-for="(facet,index) in additionalFilter" :class="facet.classes" class="filter-column">
                            <component v-bind:is="facet.component" v-model="selections[facet.facetName]"
                                       v-bind:config="facet" v-bind:facet="bindings[facet.binding]"
                                       @input="updateFilter($event)"></component>
                        </div>

                    </div>
                </div>
                <div class="result-display-options result option">
                    <div class="dropdown results-sorting mr-xs" v-if="!!options.language">
                        <button class="btn btn-flat dropdown-toggle" data-toggle="dropdown" type="button"><i
                            class="icon"
                            :class="[!currentResultLanguage ? 'icon-locale' : 'icon-flag-'+currentResultLanguage ]"></i><span>{{
                                currentResultLanguage ? currentResultLanguage.toUpperCase() : $t("service_download.option_language")
                            }}</span>
                            <span class="caret"></span></button>
                        <ul class="dropdown-menu">
                            <li v-for="language in lang" :class="{'active' : currentResultLanguage === language }"><a
                                :class="['sort-'+language]"
                                class="action action-filter"
                                v-on:click.stop="setResultLanguage(language,$event)"><i
                                :class="['icon-flag-'+language]"
                                class="icon icon-flag"></i><span>{{ language.toUpperCase() }}</span></a>
                            </li>
                        </ul>
                    </div>
                    <div class="dropdown results-sorting" v-if="options.sortings">
                        <button class="btn btn-flat dropdown-toggle" data-toggle="dropdown" type="button"><i
                            class="icon icon-sorting"></i>{{ sortingText }}
                            <span class="caret"></span></button>

                        <ul class="dropdown-menu">
                            <li v-for="sort in sortings" :class="{'active' : sorting === sort }"><a
                                :class="['sort-'+sort]"
                                class="action action-filter"
                                v-on:click.stop="setSorting(sort,$event)">{{
                                    $t("service_download.filter_sorting." + sort)
                                }}</a>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>

        </div>


        <div v-show="resultsCount===0 && resultState ==='finished'" class="result-group search-result-group info">
            {{ $t("no_results") }}
        </div>


        <slot name="results" v-bind:results="results" v-bind:groups="groups">

            <search-result-group
                v-show="resultState === 'finished' || resultState === 'updating'"
                :raw-results="results"
                :sorting="sorting"
            />
        </slot>


    </div>


</template>


<script>

    import SearchResultGroup from "./SearchResultGroup";
    import FilterFacetCategory from "@/components/FilterFacetCategory";
    import FilterFacetTypeId from "@/components/FilterFacetTypeId";
    import FilterFacetLang from "@/components/FilterFacetLang";
    import VisualTokenSearch from "@/components/VisualTokenSearch";
    import dropdownResultTypes from "@/dropdownResultTypes";
    import Loader from "./Loader";
    import FilterCategoryLabelCloud from "@/components/FilterCategoryLabelcloud";
    import FacetCheckboxItem from "@/components/facet/FacetCheckboxItem";
    import {mapState} from "vuex";
    import CategoryFilter from "@/components/CategoryFilter";

    let scrollOptions = {
        force: true,
        cancelable: true,
        offset: -100
    };

    let defaultFacets = [
        {
            component: FilterFacetTypeId,
            binding: 'level_0',
            classes: [],
            facetName: 'level_0',
            getOptionName: function (id) {
                let filter = this.$options.filters.category;
                let name = filter(id);
                return name;
            }
        }, {
            component: FilterFacetTypeId,
            binding: 'type_id',
            classes: [],
            facetName: 'type_id',
            getOptionName: function (id) {
                return this.$t("service_download.types." + id.replace('.', ':'));
            }
        }, {
            component: FilterFacetTypeId,
            binding: 'lang',
            classes: [],
            facetName: 'lang',
            getOptionName: function (id) {
                return id.toUpperCase();
            },
            filterOptions(option) {
                return option.toLowerCase() !== 'nn';
            }
        }];

    export default {
        name: "SearchResult",
        props: {
            'facets': Array,
            'grouped': Boolean,
            'options': {
                type: Object, default: () => {
                    return {sortings: true}
                }
            },
            hideCategories: {
                type: Boolean
            }
        },
        data: function () {
            return {
                resultTypes: dropdownResultTypes,
                sortings: [
                    'asc', 'desc', 'date_asc', 'date_desc', 'relevance'
                ],
                selections: {
                    type_id: [],
                    lang: [],
                },
                sorting: 'relevance',
                additionalFilter: defaultFacets,
                query: {},
                currentResultLanguage: null,
            };
        },
        watch: {
            resultState(newVal, oldVal) {
                if (newVal == 'loading') {
                    this.selections.type_id.splice(0, this.selections.type_id.length);
                    this.selections.lang.splice(0, this.selections.type_id.length);
                }
            },
            facets() {
                if (this.facets)
                    this.additionalFilter = this.facets;
            },
            results() {
                if (this.results) {
                    this.$scrollTo(this.$el, 200, scrollOptions);
                }
            },
            types() {
                this.selections.searchFilter = this.$store.state.selections.searchFilter
            },
        },
        components: {
            CategoryFilter,
            FilterFacetCategory,
            SearchResultGroup,
            FilterFacetTypeId,
            FilterFacetLang,
            FacetCheckboxItem,
            VisualTokenSearch,
            Loader,
        },
        methods: {
            hasFilterSelected() {

                for (var id in this.selections) {
                    if (this.selections.hasOwnProperty(id)) {
                        var options = this.rawResults[id];
                        if (options.length > 0)
                            return true;
                    }
                }

                return false;
            },
            hasFilter() {
                if (Object.keys(this.bindings).length)
                    return true;

                if (this.types || this.lang)
                    return true;

                return false;
            },
            filterResults() {
                this.$store.dispatch('getResults').then(function () {
                });
            },
            languageFilter(result) {
                let self = this;
                if (this.selections.languageFilter.length === 0)
                    return true;
                let lang = result.existing_languages.filter((value) => {
                    let filtered = self.selections.languageFilter.filter((i) => {
                        return i.id === value && i.selected;
                    });

                    return filtered.length > 0;
                });

                if (lang.length > 0)
                    return true;
            },
            setResultLanguage(language, event) {
                this.currentResultLanguage = language;
                this.$store.commit('setResultLanguage', language);
            },
            updateFilter(e) {
                this.updateQuery();
                this.filterResults();
            },
            updateQuery() {
                this.$store.commit('setSearchFilter', this.selections || []);
                this.$store.commit('setOptions', {'resetQuery': false});
            },
            setSorting(sort, e) {
                e.preventDefault();
                this.sorting = sort;
            },
            getResults(e) {
                this.$store.commit('setSearchQuery', e);
                this.$store.dispatch('getResults', e);
            }
        },
        created() {
            this.selections.type_id = this.$store.state.selections.searchFilter;
            if (this.facets)
                this.additionalFilter = this.facets;
        },
        computed: {
            sortingText() {
                if (this.sorting === null)
                    return this.$t("service_download.filter_sorting.sorting");
                return this.$t("service_download.filter_sorting." + this.sorting);
            },
            bindings() {
                if (!this.additionalFilter)
                    return {};
                let bindings = {};

                for (let i = 0; i < this.additionalFilter.length; i++) {
                    let facet = this.additionalFilter[i];

                    if (!facet.binding)
                        continue;

                    if (this.$store.state.resultFilter && this.$store.state.resultFilter.facets_terms)
                        bindings[facet.binding] = this.$store.state.resultFilter.facets_terms[facet.binding];
                }

                return bindings;

            },
            search() {
                return this.$store.state.search;
            },
            filter() {
                if (this.$store.state.filter)
                    return this.$store.state.filter.facets;
            },
            types() {
                if (this.$store.state.resultFilter && this.$store.state.resultFilter.facets_terms)
                    return this.$store.state.resultFilter.facets_terms.type_id;
            },
            lang() {
                if (this.$store.state.resultFilter && this.$store.state.resultFilter.facets_terms)
                    return this.$store.state.resultFilter.facets_terms.lang;
            },
            results() {
                return this.$store.state.results;
            },
            groups() {
                let self = this;
                if (!this.grouped)
                    return [];
                let buckets = {};

                if (!this.results)
                    return buckets;

                let keys = Object.keys(this.results);
                for (var i = 0; i < keys.length; i++) {
                    const result = this.results[keys[i]];
                    if (!result.type) {
                        continue;
                    }

                    let bucket = null;
                    bucket = Array.isArray(result.type) ? result.type : [result.type];

                    if (!bucket) {
                        console.warn("Result has no type", result);
                        continue;
                    }

                    bucket.forEach(b => {

                        if (self.selections.type_id && self.selections.type_id.length > 0 && !self.selections.type_id.includes(b)) {
                            return;
                        }

                        b = b.replace('.', ':');

                        if (!buckets[b]) {
                            buckets[b] = {
                                results: {}
                            };
                        }
                        buckets[b]["results"][keys[i]] = result;
                    });

                }

                let sorted = {};

                keys = Object.keys(buckets);

                keys = keys.sort((a, b) => self.$t('service_download.types.' + a) > self.$t('service_download.types.' + b) ? 1 : -1);
                keys.forEach(i => sorted[i] = buckets[i]);

                return sorted;
            },
            resultsCount() {
                if (!this.results)
                    return 0;
                return Object.keys(this.results).length;
            },
            resultState() {
                return this.$store.state.status.results;
            }
        }
    }
</script>

<style lang="less">


  .service-results {

    .flex-row {
      display: flex;
      justify-content: stretch;
    }

    .filter-column {
      padding: 0 8px;
      width: 100%;
    }

    .category-filter {
      margin: 10px 0 20px;
    }

    .result-group {
      position: relative;
    }

    .service-resultoptions {


      h3 {
        font-size: 17px;
        margin-bottom: 15px;
      }

      display: flex;
      position: relative;
      padding-bottom: 15px;
      margin-bottom: 15px;
      justify-content: flex-end;
      flex-wrap: wrap;

      @media (max-width: 767px) {
        &.collapse {
          display: none;
          overflow: hidden;

          &.in {
            display: flex;
          }
        }

        flex-wrap: wrap;
      }


    }

    .results-filter {
      flex-basis: 100%;
      text-align: left;
      font-size: 14px;
      padding-bottom: 20px;
      border-bottom: 1px solid #cfd2d1;
      margin-bottom: 20px;

      .result-filter {
        border-right: 1px solid #cfd2d1;
        padding-right: 10px;


      }

    }

    @media (min-width: 992px) {
      .results-filter {
        flex-basis: 100%;
      }
    }


    .results-sorting {
      flex-basis: 25%;
    }


    .filter-title {
      font-size: 14px;
      font-weight: bold;
      margin: 0;
      margin-bottom: 8px;
      padding: 0;
    }

    .facet-filter {


      @media (max-width: 767px) {

        .btn.toggle-xs {
          padding: 10px 0;
          border-width: 0;
          border-bottom: 1px solid transparent;
          border-color: #cccccc;
          border-top: 1px solid transparent;


        }

        .active {
          .btn.toggle-xs {
            border-bottom-color: transparent;
          }

          + .collapse {
            margin-bottom: 10px;
          }
        }

        .collapse.in {
          max-height: none;
        }

        &.facet-languages {
          li {
            display: inline-block;
            min-width: 60px;
            width: 25%;
          }
        }
      }


      .scroll-content {
        min-height: 0;
        height: auto;
        max-height: 120px;
      }

      ul {
        margin: 0;
        padding: 0;
        list-style: none;
      }

      .checkbox {
        margin: 0;
      }

      .result.count {
        color: #9f9f9f;
      }

      .badge {
        margin: 2px;
      }
    }

    .btn.toggle-xs {
      padding: inherit;
      font-size: inherit;
      font-weight: inherit;
      display: inherit;
      text-align: inherit;

      &:active {
        box-shadow: none;
      }
    }

    .btn {

      &[data-toggle] {
        .icon-toggle-state {
          float: right;
          height: 24px;
          background-position-y: center;
          background-image: url('/siauv4/bootstrap/assets/img/icon_arrow_down.svg');
          transform: rotate(180deg);
          transition: transform .5s ease;

        }

        @media (min-width: 992px) {
          .icon-toggle-state {
            display: none;
          }
        }

        &.collapsed {
          .icon-toggle-state {
            transform: rotate(0deg);
            background-image: url('/siauv4/bootstrap/assets/img/icon_arrow_down.svg');
          }

        }
      }

      &.btn-resultoptions {
        display: block;
        text-align: left;
        padding: 10px 20px;
      }


      &[data-toggle="collapse-next"] {
        .icon-toggle-state {
          transform: rotate(0deg);
        }
      }
    }


    .active {
      > [data-toggle] {

        .icon-toggle-state {
          transform: rotate(180deg);
          background-image: url('/siauv4/bootstrap/assets/img/icon_arrow_down.svg');
        }
      }
    }

    @media (min-width: 992px) {
      .filter-column {
        padding: 0 8px;
        flex-grow: 1;
        width: auto;
      }

      .facet-filter > .collapse {
        height: 120px;
        display: block;
      }

    }
  }


</style>
